import '../../assets/css/colors.css'
import '../../assets/css/Principais.css'
import '../../assets/css/fonts.css'
import TopMenu from '../TopMenu'
import { useEffect, useState, useReducer, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import Sacola from '../subComponents/Sacola'
import { fillInformation } from '../subComponents/TirarPedidoReducer'
import { ConsultaCliente, ConsultaProdutos, ConsultaRevistaEFornecedores, InsertPedido } from '../funcionalidades/bancoGet'
import Swal from 'sweetalert2'
import { ShowProdutosDisponiveis } from '../subComponents/TirarPedidoEscolheProd'
import { ProdutoPagina } from '../subComponents/ProdutoPagina'
import GlobalVar from '../subComponents/GlobalVar'
import FiltroEOrdenacoes from '../subComponents/FiltroEOrdenacoes'
import { copiarLink } from '../funcionalidades/copiarLink'



const compartilhar = async (pedido, avisar = false) => {
  const url = `https://encomendas.babita.com.br/PedidoRelatorioCliente?doc=${pedido}`;

  if (navigator.share) {
    try {
      await navigator.share({
        title: "Pedido",
        text: "Veja esse pedido",
        url: url,
      });
    } catch (err) {
      console.log("Erro ao compartilhar:", err);
    }
  } else {
    // fallback (desktop ou navegador antigo)
    await copiarLink(url, { avisar });
  }
};


const TelasTirarPedido = ({stateInfo, dispachInfo, filtroRef})=>{
  
  useEffect(()=>{
    if(stateInfo.telaAtual == 0 || stateInfo.telaAtual == 1){
      dispachInfo({type: 'produtoPagina', value: {}})
    }
  },[stateInfo.telaAtual])

  switch(stateInfo.telaAtual){
    case 0:
      return <div className='insertClient'>
        {stateInfo.clientData ? <><div className="clienteNome">{stateInfo.clientData["NOME PARCEIRO"]}</div>  </> : <></>}
        <input type="text" className="cpfcnpj" placeholder={"CPF OU CNPJ"}
              onChange={(e)=>dispachInfo({type: 'cpfCnpj', value: e.target.value.replace(/[\/.\-\s\\\\]/g, "")})} value={stateInfo.cpfCnpj} />
        {stateInfo.clientData ? <>
        <div className="buttonConfirm" onClick={()=>dispachInfo({type: 'telaAtual', value: 1})}>Confirmar Cliente e Prosseguir?</div>
        </> : <></>}
      </div>
    case 1:
      return <div className="insertPedido">
        <div className="infoparc">
          <div>{stateInfo.clientData["NOME PARCEIRO"]}</div>
          <div>{stateInfo.clientData["CPF OU CNPJ"]}</div>
        </div>

        <div className="topOptions">
          <div className="FiltroBtn"
          onClick={()=>{filtroRef.current.setShowLateralFiltroEOrdenacao(true)}} ><div className="filtroImg"></div> <div className="text">Filtros e Ordenações</div> </div>
        </div>

        <div className="produtosDisponiveis">
          { stateInfo.produtos && stateInfo.produtos.length > 0 ? 
              <ShowProdutosDisponiveis produtos={stateInfo.produtos} showStyle={true} dispachInfo={dispachInfo} stateInfo={stateInfo}/> : <></>}
        </div>
      </div>
    case 2:
      return <ProdutoPagina dispachInfo={dispachInfo} stateInfo={stateInfo} showStyle={true}/>

  }


}

export default function TirarPedido({ativaResp,showStyle}){

  const usuario = GlobalVar.getSessionStorage('usuario')
  const now = new Date();

  const data = now.getFullYear() + '-' +
    String(now.getMonth() + 1).padStart(2, '0') + '-' +
    String(now.getDate()).padStart(2, '0');

  const hora = String(now.getHours()).padStart(2, '0') + ':' +
    String(now.getMinutes()).padStart(2, '0');

    const navigate = useNavigate();
    const [stateInfo, dispachInfo] = useReducer(fillInformation,{telaAtual: 0, cpfCnpj: '', clientData: null,
  produtos: [], produtosSacola: {}, produtoPagina: {}, produtoPaginaSelectedInfo: {},
    quantidadeTotalSacola: 0, valorTotalSacola: 0, pedidoFinalizado: false, revistas: "", revistaSelecionada: "", categorias: "", categoriaSelecionada: ""})

  
  const sacolaRef = useRef()
  const filtroRef = useRef()
  

      useEffect(() => {
        if (showStyle) {
          // Importa dinamicamente quando necessário
          import('../../assets/css/estiloPaginas/tirarPedido.css');
        }
      }, [showStyle]);

      useEffect(()=>{
        if(stateInfo.cpfCnpj.length >= 14 || stateInfo.cpfCnpj.length == 11){
          ConsultaCliente({CPFCNPJ: stateInfo.cpfCnpj})
            .then((resp)=>{
              if(resp.Error){
                if(stateInfo.cpfCnpj.length == 14){
                  Swal.fire({
                    type: 'error',
                    title: 'Cliente não Encontrado',
                    text: 'Certifique-se de preencher somente os numeros do cpf/cnpj'
                  })
                }
              }else{
                dispachInfo({type: 'clientData', value: resp[0]})
                ConsultaRevistaEFornecedores({CPFCNPJ: stateInfo.cpfCnpj})
                .then((resp)=>{
                  if(resp.Error){
                    Swal.fire({
                      type: 'error',
                      title: 'Error',
                      text: 'Sem Revistas. Servidor Indisponivel, contacte a TI.'
                    })
                  }else{
                    dispachInfo({type: 'revistas', value: resp})
                    dispachInfo({type: 'revistaSelecionada', value: resp[0].rev_num_rev})
                  }
                })
              }
            })
          }
        },[stateInfo.cpfCnpj])
        
        useEffect(()=>{
          if(parseInt(stateInfo.revistaSelecionada) >= 0 && stateInfo.revistaSelecionada != "" && stateInfo.revistaSelecionada){
            ConsultaProdutos({NUMREV: stateInfo.revistaSelecionada, LOGINRELACIONAMENTO: false})
            .then((resp)=>{
              if(resp.Error){
                Swal.fire({
                  type: 'error',
                  title: 'Nenhum Produto Encontrado',
                  text: 'Tente Selecionar Outra Revista/Colecao'
                })
              }else{
                dispachInfo({type: 'produtos', value: resp})
              }              
            })
        }
      },[stateInfo.revistaSelecionada])

      useEffect(()=>{
        if(!stateInfo.pedidoFinalizado) return;
        // console.log(stateInfo)
        InsertPedido({CLIENTDATA: stateInfo.clientData, PRODUTOSSACOLA: stateInfo.produtosSacola, 
          QTDETOTAL: stateInfo.quantidadeTotalSacola, VALORTOTAL: stateInfo.valorTotalSacola, 
          USER: usuario, DATA_ABERTURA: data, HORA_ABERTURA: hora})
          .then((resp)=>{
            if(resp.Error || resp["ERROR SERVER"]){
              Swal.fire({
                type: 'error',
                title: 'Error',
                text: 'Pedido Não Finalizado, tente novamente ou contacte a TI.'
              })
              dispachInfo({type: 'pedidoFinalizado', value: false})
            }else{
                Swal.fire({
                  icon: 'success',
                  title: 'Pedido Finalizado',
                  // timer: 1000
                })
                // if(sacolaRef.current){
                //   sacolaRef.current.setShowLateralSacola(true)
                // }
                dispachInfo({type: 'produtosSacola', value: {}})
                dispachInfo({type: 'pedidoFinalizado', value: false})
                compartilhar(resp.pedido)
                
              }              
            })
        
      },[stateInfo.pedidoFinalizado])

    return <>
    <TopMenu ativaResp={ativaResp} showStyle={true} sacolaRef={sacolaRef}stateInfo={stateInfo}>
      <Sacola ref={sacolaRef} showStyle={true}  ativaResp={ativaResp} stateInfo={stateInfo} dispachInfo={dispachInfo}/>
      <FiltroEOrdenacoes ref={filtroRef} showStyle={true}  ativaResp={ativaResp} stateInfo={stateInfo} dispachInfo={dispachInfo}/>
    </TopMenu>

        <div className="containerPrincipal tirarPedido" style={{minHeight: "91vh", display: 'flex',
    flexDirection: 'column'}}>
          {stateInfo.telaAtual < 2 ? <div className="title">Tirar Pedido</div> : <></>}

            <TelasTirarPedido stateInfo={stateInfo} dispachInfo={dispachInfo} showStyle={true} filtroRef={filtroRef}/>

        </div>
    </>
}



